import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash && hash.startsWith('#')) {
      const id = hash.substring(1);

      const scrollToTarget = () => {
        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };

      // Try immediately first
      if (!scrollToTarget()) {
        // Then watch for DOM changes until the element shows up
        const observer = new MutationObserver(() => {
          if (scrollToTarget()) {
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        // Safety timeout
        setTimeout(() => observer.disconnect(), 5000);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
